import { AwsRum } from "aws-rum-web";
import { isLocal } from "./utils";

export let awsRum;

export async function initAwsRum() {
  try {
    if (isLocal()) return;

    const config = {
      sessionSampleRate: 1,
      identityPoolId: "us-east-1:4fd8b168-1629-4fba-8131-75a1af4d5962",
      endpoint: "https://dataplane.rum.us-east-1.amazonaws.com",
      telemetries: ["performance", "errors", "http"],
      allowCookies: true,
      enableXRay: true,
    };

    const APPLICATION_ID = "d670e177-6e21-4612-b770-5b3efe88d87b";
    const APPLICATION_VERSION = "1.0.0";
    const APPLICATION_REGION = "us-east-1";

    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config
    );
    
    return awsRum;
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.log(error);
  }
}

export const sendCustomRUMEvent = (eventName, eventData) => {
  if (isLocal()) return;
  awsRum.recordEvent(eventName, eventData);
};
